// The mode card's template, card.mode (contract §8.3): ModeCardView
// (cloud/web/src/components/board/BoardCards.tsx) through the mode status
// (§4.9): the headline ("Anchored", "Can't tell") and its caption. The card is
// the status card with the mode's icon and its tag (§6.2).

import { css, h, output } from "./kit.js";

const CSS = css(`
  .md { gap: 12px; }
  .md-h { font: 700 28px/1.15 var(--tc-font-rounded); color: var(--text); }
  .md-h[data-quality=stale], .md-h[data-quality=missing], .md-h[data-state=unknown] { color: var(--muted); }
  /* At night a stale value keeps the text colour: grey under the night tint reads below the app's own values (§9.6, TOM-665). */
  html[data-theme=night] .md-h[data-quality=stale]:not([data-state=unknown]) { color: var(--text); }
  .md-c { min-height: 1.35em; font: 400 13px/1.35 var(--tc-font-sans); color: var(--muted); }
`);

/** card.mode: the boat's mode (§8.3). */
export function cardMode() {
  return output("card.mode", 1, {
    html: h(
      "div",
      { class: "tp md" },
      h("p", {
        class: "md-h",
        "data-tc-status": "mode",
        "data-tc-field": "word",
      }),
      h("p", {
        class: "md-c",
        "data-tc-status": "mode",
        "data-tc-field": "caption",
      }),
    ),
    css: CSS,
    card: {
      kind: "status",
      icon: "mode",
      meta: { status: "mode", field: "tag" },
    },
  });
}
